export interface EJOTProductImageRecord {
  aliases: readonly string[];
  localAsset?: string;
  sourceUrl: string;
  imageSourceUrl?: string;
  retrievedAt?: string;
}

/**
 * Product imagery is deliberately presentation-only and local-first.
 * `localAsset` is set only after an official EJOT image has been copied into
 * the repository. Runtime hotlinking to EJOT is not permitted.
 */
export const EJOT_PRODUCT_IMAGES: readonly EJOTProductImageRecord[] = [
  {
    aliases: ['JBS-R-7.5', 'JBS-R-7,5', 'JBS-R 7.5', 'JBS-R 7,5'],
    sourceUrl: 'https://www.ejot.com/Building-Fasteners/Products/Concrete-Aerated-Concrete-Screws/JBS-R-7-5/p/JBS-R-7_5',
    imageSourceUrl: 'https://www.ejot.com/medias/sys_master/products/products/hae/h03/9002915069982/-JBS-R-7-5-Produktbild-500Wx500H.png',
  },
];

export function localEJOTProductImage(productCode: string | undefined): string | undefined {
  if (!productCode) return undefined;
  const normalized = normalize(productCode);
  const match = EJOT_PRODUCT_IMAGES.find((record) => record.aliases.some((alias) => normalized.includes(normalize(alias))));
  return match?.localAsset;
}

function normalize(value: string): string {
  return value.toUpperCase().replace(/[,\s_]+/g, '-').replace(/-+/g, '-').trim();
}
